import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { VAIRABLES } from "../config";
import "./venmo.css";

const PayWithVenmo = () => {
  const [amount, setAmount] = useState(100);
  const [queryParams, setQueryParams] = useState({});

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const params = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });

    setQueryParams(params);
    if (params.amount) {
      setAmount(params.amount);
    }
  }, [searchParams]);

  return (
    <div className="paymentBody">
      <PayPalScriptProvider
        options={{
          "client-id": VAIRABLES.PAYPAL_CLIENT_ID,
          "enable-funding": VAIRABLES.ENABLE_FUNDING,
          "disable-funding": VAIRABLES.DISABLE_FUNDING,
          // CORRECT - uses "capture" for negative balance payments
          intent: searchParams?.get('InsufficientFund') === 'true' ? "capture" : 
                  (searchParams?.get('negativeBalance') || searchParams?.get('driverTip') || searchParams?.get('riderRequestId') ? "capture" : "authorize"),
//          intent: searchParams?.get('driverTip') || searchParams?.get('riderRequestId') ? "capture" : "authorize",
        }}
      >
        <PayPalButtons
          style={{ layout: "vertical" }}
          createOrder={(data, actions) => {
            return actions.order
              .create({
                purchase_units: [
                  {
                    amount: {
                      value: amount,
                    },
                     custom_id: JSON.stringify({
                      ...queryParams,
                      riderId: searchParams?.get('riderId') || "",
                      rider_id: searchParams?.get('rider_id') || "",
                      InsufficientFund: searchParams?.get('InsufficientFund') === 'true',  // ✅ ADD THIS
                      negativeBalance: searchParams?.get('negativeBalance') || false,
                      isDriverTip: true,
                      driverId: searchParams?.get('driverId')
                    }),
                    application_context: {
                      return_url: VAIRABLES.PAYPAL_RETURN_URL,
                      cancel_url: VAIRABLES.PAYPAL_SUCCESS_URL,
                    }
                  },
                ],
              })
              .then((orderID) => {
                return orderID;
              });
          }}
          onApprove={(data, actions) => {
            navigate("/success"); // Navigate to success route
          }}
          onError={(err) => {
            console.error("Payment Error: ", err);
            navigate("/error"); // Navigate to error route
          }}
        />
      </PayPalScriptProvider>
    </div>
  );
};

export default PayWithVenmo;